import  { Fragment, useEffect } from "react";
import PageTitle from "../../layouts/PageTitle";
import DonorTable from "./Table/DonorTable";
import { useDonor } from "../../../context/donor/donor.context";
import {useParams} from "react-router-dom"

const DonorsTables = () => {
  const {type} = useParams();
  const {     
    eligibleDonors,
    nonEligibleDonors,
    donorsThatVistMoreThanThreeTimes,
    totalEligibleDonors,
    totalNonEligibleDonors,
    totalDonorsThatVistMoreThanThreeTimes,
    fetchDonorsByType
  } = useDonor();


    useEffect(() => {
      fetchDonorsByType(type,0,10);
    },[type])

      let displayedDonors = [];
  let totalDonors = 0;
  if (type === "eligible") {
    displayedDonors = eligibleDonors;
    totalDonors = totalEligibleDonors;
  } else if (type === "non-eligible") {
    displayedDonors = nonEligibleDonors;
    totalDonors = totalNonEligibleDonors;
  } else if (type === "visited-more-than-three") {
    displayedDonors = donorsThatVistMoreThanThreeTimes;
    totalDonors = totalDonorsThatVistMoreThanThreeTimes;
  }
  return (
    <Fragment>
    <PageTitle
      activeMenu="Donors"
      motherMenu="Table"
      pageContent="Donors"
    />
    <div className="row">
        <DonorTable eligibleDonors={displayedDonors} totalEligibleDonors={totalDonors} fetchDonorsByType={fetchDonorsByType}/>
    </div>
  </Fragment>
  )
}

export default DonorsTables